// extracted by mini-css-extract-plugin
export default {"bottomBar":"SidebarFooter_bottomBar__2lDWB","name":"SidebarFooter_name__iWMJZ"};